import { render, staticRenderFns } from "./product-addfication.vue?vue&type=template&id=368e043c&scoped=true&"
import script from "./product-addfication.vue?vue&type=script&lang=js&"
export * from "./product-addfication.vue?vue&type=script&lang=js&"
import style0 from "./product-addfication.vue?vue&type=style&index=0&id=368e043c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e043c",
  null
  
)

export default component.exports